function libertyBlackPrompt() {
    return `
    Bạn tên là Liberty, bạn có thể trả lời bằng tất cả ngôn ngữ mà người dùng sử dụng để hỏi, bạn là trợ lý ảo AI của StarGlobal 3D – doanh nghiệp Khoa học Công nghệ chuyên về các giải pháp Số hóa 3D. Liberty mang ý nghĩa “tự do”, giúp người dùng dễ dàng tương tác, khám phá không gian 3D/360 số hóa chỉ bằng trò chuyện, không cần thao tác thủ công. Bạn hỗ trợ thuyết minh, tạo tour, xem mô hình 3D, mở video, tài liệu...
    StarGlobal 3D sở hữu bằng sáng chế của USPTO cho “Web/App 3D/360 tương tác thông minh”, cho phép tái hiện không gian thực dưới dạng web tương tác 3D/360, truy cập từ xa mọi lúc, mọi nơi.
    Giải pháp tích hợp ảnh 360, đo đạc kích thước, thông tin đa phương tiện (audio, video, ảnh, bản đồ), tương tác mô hình 3D, đổi họa tiết sản phẩm. Ứng dụng đa ngành: Du lịch, Bảo tàng, Di sản, Trường học, Hạ tầng, Bất động sản, Nhà máy, Trang trại, Showroom, Triển lãm...
    Liên hệ:
    
    Hotline: (+84) 28 7303 4879 | (+84) 944 850 527
    Founder & CEO: Ông Trần Duy Hào – Tiến sĩ danh dự, nhà sáng chế được USPTO cấp bằng sáng chế cho hệ thống quản lý thông minh bản đồ số hóa 3D/360 (https://patents.google.com/patent/US10922881B2/en), hơn 20 năm kinh nghiệm quốc tế trong Chuyển đổi số, Dầu khí, Hàng không.
    Tính năng nổi bật:
    Công nghệ độc quyền, bảo hộ tại Mỹ & Việt Nam
    Tương tác tối ưu: autotour, đo đạc 3D/360, virtual check-in, chia sẻ mạng xã hội
    Kết nối IoT dữ liệu thời gian thực
    Đa nền tảng: di động, máy tính, kính VR, v.v.

    `
}

function libertyBlackAvatar(nodes, materials) {
    return (
        <group position={[0, 0.077, 0]}>
            <skinnedMesh
                geometry={nodes.Coat001.geometry}
                material={materials.Coat_low_Rigging_13624_Coat}
                skeleton={nodes.Coat001.skeleton}
            />
            <skinnedMesh
                name="Eyelashes001"
                geometry={nodes.Eyelashes001.geometry}
                material={materials.Eyelashes}
                skeleton={nodes.Eyelashes001.skeleton}
                morphTargetDictionary={nodes.Eyelashes001.morphTargetDictionary}
                morphTargetInfluences={nodes.Eyelashes001.morphTargetInfluences}
            />
            <skinnedMesh
                name="EyeLeft"
                geometry={nodes.EyeLeft.geometry}
                material={materials.tear}
                skeleton={nodes.EyeLeft.skeleton}
                morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
            />
            <skinnedMesh
                name="EyeRight"
                geometry={nodes.EyeRight.geometry}
                material={materials.tear}
                skeleton={nodes.EyeRight.skeleton}
                morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
            />
            <skinnedMesh
                geometry={nodes.Pantie001.geometry}
                material={materials.Pantie}
                skeleton={nodes.Pantie001.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Skirt001.geometry}
                material={materials.Skirt}
                skeleton={nodes.Skirt001.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Zipper001.geometry}
                material={materials.Zipper02_Zipper}
                skeleton={nodes.Zipper001.skeleton}
            />
            <primitive object={nodes.hip} />
            <skinnedMesh
                name="tear002"
                geometry={nodes.tear002.geometry}
                material={materials['Eyebrows.001']}
                skeleton={nodes.tear002.skeleton}
                morphTargetDictionary={nodes.tear002.morphTargetDictionary}
                morphTargetInfluences={nodes.tear002.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear002_1"
                geometry={nodes.tear002_1.geometry}
                material={materials.Eyebrows}
                skeleton={nodes.tear002_1.skeleton}
                morphTargetDictionary={nodes.tear002_1.morphTargetDictionary}
                morphTargetInfluences={nodes.tear002_1.morphTargetInfluences}
            />
            <skinnedMesh
                geometry={nodes.Hair_LowPonytail001_1.geometry}
                material={materials.LowPonytail_Back}
                skeleton={nodes.Hair_LowPonytail001_1.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_LowPonytail001_2.geometry}
                material={materials.LowPonytail_BackUnder}
                skeleton={nodes.Hair_LowPonytail001_2.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_1.geometry}
                material={materials.Ponytail_Base_Front2}
                skeleton={nodes.Hair_Ponytail_Base001_1.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_2.geometry}
                material={materials.Ponytail_Base_Front1}
                skeleton={nodes.Hair_Ponytail_Base001_2.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_3.geometry}
                material={materials.Ponytail_Base_Side2}
                skeleton={nodes.Hair_Ponytail_Base001_3.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_4.geometry}
                material={materials.Ponytail_BaseBangs2}
                skeleton={nodes.Hair_Ponytail_Base001_4.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_5.geometry}
                material={materials.Ponytail_Base_Side1}
                skeleton={nodes.Hair_Ponytail_Base001_5.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_6.geometry}
                material={materials.Ponytail_Base_Bangs1}
                skeleton={nodes.Hair_Ponytail_Base001_6.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Hair_Ponytail_Base001_7.geometry}
                material={materials.Ponytail_Base_Cap}
                skeleton={nodes.Hair_Ponytail_Base001_7.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_1.geometry}
                material={materials.HeelL_Sole_1}
                skeleton={nodes.HeelL001_1.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_2.geometry}
                material={materials.HeelL_SoleSide_1}
                skeleton={nodes.HeelL001_2.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_3.geometry}
                material={materials.HeelL_Leather_1}
                skeleton={nodes.HeelL001_3.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_4.geometry}
                material={materials.HeelL_Inner_1}
                skeleton={nodes.HeelL001_4.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_5.geometry}
                material={materials.HeelL_HeelTip_1}
                skeleton={nodes.HeelL001_5.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_6.geometry}
                material={materials.HeelL_Inner_L_1}
                skeleton={nodes.HeelL001_6.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_7.geometry}
                material={materials.HeelL_Heel_1}
                skeleton={nodes.HeelL001_7.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_8.geometry}
                material={materials.HeelL_Leather_In01_1}
                skeleton={nodes.HeelL001_8.skeleton}
            />
            <skinnedMesh
                geometry={nodes.HeelL001_9.geometry}
                material={materials.HeelL_Leather_In02_1}
                skeleton={nodes.HeelL001_9.skeleton}
            />
            <skinnedMesh
                name="HeelR001_1"
                geometry={nodes.HeelR001_1.geometry}
                material={materials.HeelR_Sole}
                skeleton={nodes.HeelR001_1.skeleton}
                morphTargetDictionary={nodes.HeelR001_1.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_1.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_2"
                geometry={nodes.HeelR001_2.geometry}
                material={materials.HeelR_SoleSide}
                skeleton={nodes.HeelR001_2.skeleton}
                morphTargetDictionary={nodes.HeelR001_2.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_2.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_3"
                geometry={nodes.HeelR001_3.geometry}
                material={materials.HeelR_Leather}
                skeleton={nodes.HeelR001_3.skeleton}
                morphTargetDictionary={nodes.HeelR001_3.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_3.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_4"
                geometry={nodes.HeelR001_4.geometry}
                material={materials.HeelR_Inner}
                skeleton={nodes.HeelR001_4.skeleton}
                morphTargetDictionary={nodes.HeelR001_4.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_4.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_5"
                geometry={nodes.HeelR001_5.geometry}
                material={materials.HeelR_HeelTip}
                skeleton={nodes.HeelR001_5.skeleton}
                morphTargetDictionary={nodes.HeelR001_5.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_5.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_6"
                geometry={nodes.HeelR001_6.geometry}
                material={materials.HeelR_Inner_L}
                skeleton={nodes.HeelR001_6.skeleton}
                morphTargetDictionary={nodes.HeelR001_6.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_6.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_7"
                geometry={nodes.HeelR001_7.geometry}
                material={materials.HeelR_Heel}
                skeleton={nodes.HeelR001_7.skeleton}
                morphTargetDictionary={nodes.HeelR001_7.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_7.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_8"
                geometry={nodes.HeelR001_8.geometry}
                material={materials.HeelR_Leather_In01}
                skeleton={nodes.HeelR001_8.skeleton}
                morphTargetDictionary={nodes.HeelR001_8.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_8.morphTargetInfluences}
            />
            <skinnedMesh
                name="HeelR001_9"
                geometry={nodes.HeelR001_9.geometry}
                material={materials.HeelR_Leather_In02}
                skeleton={nodes.HeelR001_9.skeleton}
                morphTargetDictionary={nodes.HeelR001_9.morphTargetDictionary}
                morphTargetInfluences={nodes.HeelR001_9.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001"
                geometry={nodes.tear001.geometry}
                material={materials['Mia Female Character_Body']}
                skeleton={nodes.tear001.skeleton}
                morphTargetDictionary={nodes.tear001.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_1"
                geometry={nodes.tear001_1.geometry}
                material={materials['Mia Female Character_Face']}
                skeleton={nodes.tear001_1.skeleton}
                morphTargetDictionary={nodes.tear001_1.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_1.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_2"
                geometry={nodes.tear001_2.geometry}
                material={materials['Mia Female Character_Lips']}
                skeleton={nodes.tear001_2.skeleton}
                morphTargetDictionary={nodes.tear001_2.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_2.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_3"
                geometry={nodes.tear001_3.geometry}
                material={materials['Mia Female Character_Teeth']}
                skeleton={nodes.tear001_3.skeleton}
                morphTargetDictionary={nodes.tear001_3.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_3.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_4"
                geometry={nodes.tear001_4.geometry}
                material={materials['Mia Female Character_Head']}
                skeleton={nodes.tear001_4.skeleton}
                morphTargetDictionary={nodes.tear001_4.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_4.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_5"
                geometry={nodes.tear001_5.geometry}
                material={materials['Mia Female Character_Ears']}
                skeleton={nodes.tear001_5.skeleton}
                morphTargetDictionary={nodes.tear001_5.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_5.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_6"
                geometry={nodes.tear001_6.geometry}
                material={materials['Mia Female Character_Legs']}
                skeleton={nodes.tear001_6.skeleton}
                morphTargetDictionary={nodes.tear001_6.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_6.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_7"
                geometry={nodes.tear001_7.geometry}
                material={materials['Mia Female Character_EyeSocket']}
                skeleton={nodes.tear001_7.skeleton}
                morphTargetDictionary={nodes.tear001_7.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_7.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_8"
                geometry={nodes.tear001_8.geometry}
                material={materials['Mia Female Character_Mouth']}
                skeleton={nodes.tear001_8.skeleton}
                morphTargetDictionary={nodes.tear001_8.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_8.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_9"
                geometry={nodes.tear001_9.geometry}
                material={materials['Mia Female Character_Arms']}
                skeleton={nodes.tear001_9.skeleton}
                morphTargetDictionary={nodes.tear001_9.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_9.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_10"
                geometry={nodes.tear001_10.geometry}
                material={materials['Mia Female Character_Pupils']}
                skeleton={nodes.tear001_10.skeleton}
                morphTargetDictionary={nodes.tear001_10.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_10.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_11"
                geometry={nodes.tear001_11.geometry}
                material={materials['Mia Female Character_Fingernails']}
                skeleton={nodes.tear001_11.skeleton}
                morphTargetDictionary={nodes.tear001_11.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_11.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_12"
                geometry={nodes.tear001_12.geometry}
                material={materials['Mia Female Character_Irises']}
                skeleton={nodes.tear001_12.skeleton}
                morphTargetDictionary={nodes.tear001_12.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_12.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_13"
                geometry={nodes.tear001_13.geometry}
                material={materials['Mia Female Character_Sclera']}
                skeleton={nodes.tear001_13.skeleton}
                morphTargetDictionary={nodes.tear001_13.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_13.morphTargetInfluences}
            />
            <skinnedMesh
                name="tear001_14"
                geometry={nodes.tear001_14.geometry}
                material={materials['Mia Female Character_Toenails']}
                skeleton={nodes.tear001_14.skeleton}
                morphTargetDictionary={nodes.tear001_14.morphTargetDictionary}
                morphTargetInfluences={nodes.tear001_14.morphTargetInfluences}
            />
            <skinnedMesh
                geometry={nodes.Shirt001_1.geometry}
                material={materials['Shirt_Low_Rigging_13551_<default>']}
                skeleton={nodes.Shirt001_1.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Shirt001_2.geometry}
                material={materials['Shirt_Low_Rigging_13551_Left sleeve']}
                skeleton={nodes.Shirt001_2.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Shirt001_3.geometry}
                material={materials['Shirt_Low_Rigging_13551_Right sleeve']}
                skeleton={nodes.Shirt001_3.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Shirt001_4.geometry}
                material={materials['Shirt_Low_Rigging_13551_Left cuff']}
                skeleton={nodes.Shirt001_4.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Shirt001_5.geometry}
                material={materials['Shirt_Low_Rigging_13551_Right cuff']}
                skeleton={nodes.Shirt001_5.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Stockings001_1.geometry}
                material={materials['Stockings leg']}
                skeleton={nodes.Stockings001_1.skeleton}
            />
            <skinnedMesh
                geometry={nodes.Stockings001_2.geometry}
                material={materials['Stockings top']}
                skeleton={nodes.Stockings001_2.skeleton}
            />
        </group>
    )
}


export {
    libertyBlackPrompt,
    libertyBlackAvatar,
};
